// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1mqm9","head":"Table_head__2ik9L","col":"Table_col__25Kgh"};